import { render } from "./flap.vue?vue&type=template&id=031406d3"
import script from "./flap.vue?vue&type=script&lang=js"
export * from "./flap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__